import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MainNavComponent} from './main-nav.component';
import {LoadingBarModule} from '@ngx-loading-bar/core';
import {VersionReloadComponent} from './common/version-reload.component';
import {FormsModule} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [VersionReloadComponent, LoadingBarModule, MainNavComponent, RouterOutlet, FormsModule, MatCardModule]
})
export class AppComponent {
}
